var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SvgCircle',{attrs:{"size":_vm.size,"title":_vm.statusTitle,"color":_vm.getStatusColorr(),"verticalAlign":_vm.verticalAlign,"borderColor":_vm.borderColor}})}
var staticRenderFns = []

export { render, staticRenderFns }